export const INVALID_CEP_MESSAGE = 'CEP inválido'
export const INVALID_CEP_ADRESS_MESSAGE = 'Campo obrigatório'
